// invoice http service

import { api } from './api.config'

import request from '@/utils/request'

export default {
  notice: {
    getNoticeList (data) {
      return request({
        url: api.notice.getNoticeList,
        method: 'post',
        data
      })
    }
  },
  message: {
    list (data) {
      return request({
        url: api.message.list,
        method: 'get',
        data
      })
    },
    detail (data) {
      return request({
        url: api.message.detail,
        method: 'get',
        data
      })
    },
    getMessageList (data) {
      return request({
        url: api.message.getMessageList,
        method: 'post',
        data
      })
    },
    read (data, params) {
      return request({
        url: api.message.read,
        method: 'put',
        data,
        params
      })
    }
  },
  todo: {
    getTodoList (data) {
      return request({
        url: api.todo.getTodoList,
        method: 'post',
        data
      })
    },
    getTicketLogistics (data) {
      return request({
        url: api.todo.getTicketLogistics,
        method: 'get',
        data
      })
    },
    getTicketPageByIds (data) {
      return request({
        url: api.todo.getTicketPageByIds,
        method: 'post',
        data
      })
    },
    relateLogistics (data) {
      return request({
        url: api.todo.relateLogistics,
        method: 'post',
        data
      })
    },
    markSend (data) {
      return request({
        url: api.todo.markSend,
        method: 'post',
        data
      })
    },
    updateById (data) {
      return request({
        url: api.todo.updateById,
        method: 'post',
        data
      })
    }
  },
  logistics: {
    getMatchShipper (data) {
      return request({
        url: api.logistics.getMatchShipper,
        method: 'get',
        data
      })
    },
    getshipperNameList (data) {
      return request({
        url: api.logistics.getshipperNameList,
        method: 'get',
        data
      })
    }
  }
}
